import React from "react"
import { Link } from "gatsby"
import { Content } from "bloomer"

// Índice de enlaces a las páginas de significado de cada carta/runa/cristal.
// Da enlaces internos (SEO) a las páginas programáticas desde el juego.
const SMALL = new Set(["de", "do", "da", "e", "o", "a", "dos", "das"])
const titleCase = str =>
  str
    .toLowerCase()
    .split(" ")
    .map((w, i) => (i > 0 && SMALL.has(w) ? w : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(" ")

const slugify = str =>
  str
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")

// items: array del JSON del juego. labelField: 'title' o 'name'. base: hub path.
const CardIndex = ({ items, labelField, base, heading, tarot }) => (
  <Content>
    <h2>{heading}</h2>
    <ul className="card-index">
      {items.map(item => {
        const label = item[labelField]
        const display = tarot ? titleCase(label) : label
        return (
          <li key={item.id}>
            <Link to={`${base}/${slugify(label)}/`}>{display}</Link>
          </li>
        )
      })}
    </ul>
  </Content>
)

export default CardIndex
